/**
 * Map 을 삽입 순서 기준으로 상한까지 줄인다(LRU 근사).
 *
 * 세션 동안 커지기만 하는 메모 캐시의 크기를 제한한다. 재삽입으로 최신 항목을 뒤로 옮기는
 * 일은 호출부가 한다. 이 함수는 상한을 넘은 만큼 앞에서 버리기만 한다.
 *
 * Args:
 *   entries: 줄일 Map. 제자리에서 수정한다.
 *   maxEntries: 남길 최대 항목 수.
 */
export function evictOldestBeyondCap<Value>(entries: Map<string, Value>, maxEntries: number): void {
  while (entries.size > maxEntries) {
    const oldest = entries.keys().next().value;
    if (oldest === undefined) {
      return;
    }
    entries.delete(oldest);
  }
}
